import React, { Component } from "react"
import { Link } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import rightArrow from "../assets/img/right-arrow.png";
import wpmarketing from "../assets/img/9_whatsapp_marketing.webp"
import partnerswp from "../assets/img/wp-marketing-tools-alt.webp"
import famale from "../assets/img/kampanya-duyuru.webp"
import mobileWeb from "../assets/img/sepet-hatirlatma.webp"
import clothingClothes from "../assets/img/memnuniyet.webp"

import icons1 from "../assets/img/kanal-analizi.png"
import icons2 from "../assets/img/sorun-belirleme.png"
import icons3 from "../assets/img/veri-odak.png"
import icons4 from "../assets/img/veri-toplama.png"
import icons5 from "../assets/img/kanal-olustur.png"


import kitle from "../assets/img/kitle-dogrudan.webp"
import etkilesim from "../assets/img/etkilesim.webp"
import smsmarket from "../assets/img/sms-marketing.webp"

import tetik from "../assets/img/tetik.webp"
import gonderim from "../assets/img/gonderim.webp"
import crm from "../assets/img/crm.webp"
import verliva from "../assets/img/liva-veri.webp"
import livasag from "../assets/img/liva-veri-sag.webp"
import livachat from "../assets/img/live-chat-ai.webp"
import checkModal from "../assets/img/check-modal.png";

class Gads extends Component {
  constructor(props) {
        super(props);

        this.state = {
            display: false,
            value: ''
        };
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(e) {
        e.preventDefault();

        this.setState({ value: e.target.value });
    }
    showModal() {
        this.setState({ display: !this.state.display });
        document.querySelector('.check-modal').classList.add('active-modal');
    }
    closeModal() {
        this.setState({ display: !this.state.display })
        document.querySelector('.check-modal').classList.remove('active-modal');
    }
    handleSubmit(e) {
        e.preventDefault();
        const title = document.title.split('|', 1).toString();
        const response = fetch('https://forms.flatart.com.tr/index.php?r=app%2Ff&id=7', {
            method: 'POST',
            body: JSON.stringify({
                "text_327649": title,
                "text_204202": document.querySelector('#site').value,
                "text_775908": document.querySelector('#name').value,
                "text_532192": document.querySelector('#email').value,
            }),
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        });
        response.then(res => {
            if (res.status === 200) {
                document.querySelector('.status').innerHTML = "Success!";
            }
            else {
                document.querySelector('.status').innerHTML = "Error";
            }
        });
    }
    render() {
        return (
            <Layout>
                <SEO title="WhatsApp Marketing" description="Reach your customers directly with WhatsApp marketing, boost engagement, and increase your conversion rates. Get started now with Flatart." />
                <div className="seo-service gads container">
                    <div className="seo-service__head custom">
                        <div className="col-md-6 noPadding upt">
                            <h1 className="marginzero">WhatsApp Marketing</h1>
                            <span className="red-head">SERVICES</span>
                            <p >Communicate instantly with your customers on WhatsApp through bulk messages, cart reminders, and back-in-stock alerts. Track responses and boost your sales!</p>
                            <div className="celo">
                            <input type="text" className="pink-input" placeholder="Enter your e-mail" value={this.state.value} onChange={this.handleChange} />
                            <button className="red-button" id="gads-button" onClick={(e) => this.showModal()}>Get your special offer<img alt="alt text" src={rightArrow}></img></button>
                            </div>
                            <img alt="alt text" className="wp-imgs" src={partnerswp} loading="lazy"/>
                        </div>
                        

                        <div className="col-md-6 seo-top-right" style={{ }}><img alt="alt text" src={wpmarketing} loading="lazy"/> </div>

                        <div className="check-modal">
                                                    <span onClick={(e) => this.closeModal()}>X</span>
                                                    <h2 className="form-head">Fill the form</h2>                               <p className="form-desc">Enter your information in the fields to get information, and we will get back to you as soon as possible.</p>
                                                    <div className="check-modal_container">
                                                    <form onSubmit={this.handleSubmit} >
                                                            <input type="text" name="text_204202" id="site" required  placeholder="Enter your website." />
                                                            <input type="text" id="name" required name="text_775908" placeholder="Enter your name" />
                                                            <input type="email" id="email" required  name="text_532192" value={this.state.value} onChange={this.handleChange} autoFocus={true} placeholder="Enter yor email" />
                                                            <button  >SEND</button>
                                                            <div className="status"></div>
                                                        </form>
                                                        <img alt="alt text" src={checkModal} />
                                                    </div>
                                                </div>

                    </div>
                    <div className="results-matter container py60">
                        <h2 className="wp-marketing-h2" >Marketing Process</h2>
                        <div className="container" >
                            <div className="col-md-3 desktop">
                            <div style={{textAlign: 'center'}}>
                                <img className="icons1" alt="alt text" src={icons1} loading="lazy"/>
                                <span style={{fontSize: '30px', color: '#000'}}>
                                    •
                                </span>
                                <div className="text-content">
                                    <h4 className="h3-wp" style={{margin: 0, textAlign: 'center'}}>Channel <br /> Analysis</h4>
                                </div>
                            </div>
                        </div>
                            <div className="col-md-3 desktop">
                                <div style={{textAlign: 'center'}}>
                                <img className="icons1" alt="alt text" src={icons2} loading="lazy"/>
                                <span style={{fontSize: '30px', color: '#000'}}>
                                    •
                                </span>
                                <div className="text-content">
                                    <h4 className="h3-wp" style={{margin: 0, textAlign: 'center'}}>Identify  <br></br>Customer  <br></br>Issues</h4>
                                </div>
                            </div>
                              
                            </div>
                            <div className="col-md-3 desktop">
                                  <div style={{textAlign: 'center'}}>
                                <img className="icons1" alt="alt text" src={icons3} loading="lazy"/>
                                <span style={{fontSize: '30px', color: '#000'}}>
                                    •
                                </span>
                                <div className="text-content">
                                    <h4 className="h3-wp" style={{margin: 0, textAlign: 'center'}}>Data-Driven<br></br>Marketing <br></br>Strategy</h4>
                                </div>
                            </div>
                             
                            </div>
                            <div className="col-md-3 desktop">
                                 <div style={{textAlign: 'center'}}>
                                 <img className="icons1" alt="alt text" src={icons4} loading="lazy"/>
                                <span style={{fontSize: '30px', color: '#000'}}>
                                    •
                                </span>
                                <div className="text-content">
                                    <h4 className="h3-wp" style={{margin: 0, textAlign: 'center'}}>High-Quality <br></br>Data<br></br> Collection</h4>
                                </div>
                            </div>
                              
                            </div>
                            <div className="col-md-3 desktop mobile" >
                                  <div style={{textAlign: 'center'}}>
                                 <img className="icons1" alt="alt text" src={icons5}  loading="lazy"/>
                                <span style={{fontSize: '30px', color: '#000'}}>
                                    •
                                </span>
                                <div className="text-content">
                                    <h4 className="h3-wp" style={{margin: 0, textAlign: 'center'}}>Create a<br></br> Conversion<br></br> Channel</h4>
                                </div>
                            </div>
                            
                            </div>
                        </div>
                    </div>
                    <section className="two-parp">
                    <div className="container">
                        <div className="row one">
                        <div className="col-md-5">
                        <h2 className="wp-marketing-twos">Reach Your Target Audience Directly with WhatsApp Digital Marketing</h2>
<p className="p-wp-marketings">
WhatsApp digital marketing enables brands to establish direct and highly engaging communication with customers. With bulk messaging, product promotions, campaign announcements, and event notifications reach the target audience right in their pockets. Compared to email, significantly higher open rates make this method an indispensable part of digital strategies.
</p>
</div>

                         <div className="col-md-7 right">
                            <img className="kitle" alt="alt text" src={kitle}  loading="lazy"/>
                        </div>
                      </div>
                       <div className="row two reverse-mobile">
                        <div className="col-md-7 right">
                            <img className="kitles" alt="alt text" src={etkilesim}  loading="lazy"/>
                        </div>

                     <div className="col-md-5">
  <h2 className="wp-marketing-twos">Boost Engagement with WhatsApp Marketing Services</h2>
  <p className="p-wp-marketings">
    Flatart’s WhatsApp marketing services cover the entire process from message delivery to reporting. With an easy-to-use interface, brands can upload their customer lists, schedule content, and send bulk messages with a high success rate.
  </p>
  <ul className="ul-wp">Advantages:
    <li className="li-wp"><span className="bosluk"></span>• Personalized messages</li>
    <li className="li-wp"><span className="bosluk"></span>• Time-based automated sending</li>
    <li className="li-wp"><span className="bosluk"></span>• GDPR and KVKK compliant system</li>
    <li className="li-wp"><span className="bosluk"></span>• Click and conversion rate tracking</li>
  </ul>
</div>          
                      </div>
                      <div className="row thre">
  <div className="col-md-5">
    <h2 className="wp-marketing-twos">Reduce Marketing Costs with WhatsApp Marketing</h2>
    <p className="p-wp-marketings">
      Sending messages via WhatsApp is significantly more cost-effective compared to traditional SMS campaigns. It also allows for richer content like images, links, and buttons, resulting in higher engagement.
    </p>
    <ul className="ul-wp">Comparative Advantages:
      <li className="li-wp"><span className="bosluk"></span>• Greater flexibility in characters and content</li>
      <li className="li-wp"><span className="bosluk"></span>• Measurable performance with direct conversion links</li>
      <li className="li-wp"><span className="bosluk"></span>• Potential increase of over 30% in response rates</li>
    </ul>
  </div>
  <div className="col-md-7 right">
    <img className="kitles" alt="alt text" src={smsmarket} loading="lazy" />
  </div>
</div>


                    </div>
                  </section>
                   <div className="results-matter container py30" style={{ paddingTop: 30 }}>
  <h2 className="fark-h2">Results That Make a Difference.</h2>
  <p className="fark-p">
    WhatsApp message marketing delivers quick messages that guide users directly to action. It's an ideal platform for various scenarios like product promotion, special offers, or survey sharing.
  </p>
  <div className="results-matter_box wp">
    <div className="col-md-4 matter">
      <div>
        <img alt="alt text" src={famale} loading="lazy" />
        <h3>Campaign<br /> Announcement</h3>
      </div>
    </div>
    <div className="col-md-4 matter">
      <div>
        <img alt="alt text" src={mobileWeb} loading="lazy" />
        <h3>Cart<br /> Reminder</h3>
      </div>
    </div>
    <div className="col-md-4 matter">
      <div>
        <img alt="alt text" src={clothingClothes} loading="lazy" />
        <h3>Post-Sale<br /> Satisfaction Survey</h3>
      </div>
    </div>
  </div>
</div>

                     <div className="results-matter container py40" style={{ paddingTop: 50 }}>
  <h2 className="fark-h2 ort">Automate Your Processes with Auto WhatsApp Marketing</h2>
  <p className="fark-p">
    Timing is a critical factor in marketing processes. With the <b>Auto WhatsApp Marketing</b> feature, predefined message flows are triggered automatically. This saves time and ensures seamless customer communication.
  </p>
  <p className="fark-p bold">How It Works?</p>
  <div className="results-matter_box wp">
    <div className="col-md-4 matter">
      <div>
        <img alt="alt text" src={tetik} loading="lazy" />
        <h3>Messages triggered<br /> by user behavior</h3>
      </div>
    </div>
    <div className="col-md-4 matter">
      <div>
        <img alt="alt text" src={gonderim} loading="lazy" />
        <h3>Time-based sending<br /> (e.g. birthday, membership anniversary)</h3>
      </div>
    </div>
    <div className="col-md-4 matter">
      <div>
        <img alt="alt text" src={crm} loading="lazy" />
        <h3>Synchronized message flows<br /> with your CRM system</h3>
      </div>
    </div>
  </div>
</div>




                   <div className="results-matter container py40">
  <h2 className="fark-h2 ort">We Helped Our Brands Reach Their Goals<br />and Achieved Numbers We’re Proud Of</h2>
  <p className="bold red">SUCCESS STORIES</p>
  <div className="results-matter_box">
    <div className="col-md-6">
      <div className="veriler">
        <div className="ust-satir">
          <div className="veri-grup">
            <p className="veri">+39%</p>
            <p className="veri-aciklama">Cart Conversion Rate</p>
          </div>
          <div className="veri-grup">
            <p className="veri">+63%</p>
            <p className="veri-aciklama">Read Rate</p>
          </div>
        </div>
        <div className="alt-satir">
          <img className="liva-veri" src={verliva} loading="lazy" />
          <div className="ctr-veri">
            <p className="veri">+28.57%</p>
            <p className="veri-aciklama">CTR</p>
          </div>
        </div>
      </div>
    </div>
    <div className="col-md-6">
      <img className="liva-sag" src={livasag} loading="lazy" />
    </div>
  </div>
</div>


                  <div className="seo-referances py40 container">
  <h2 className="etkili-h2">
    <b>WhatsApp vs Email Marketing</b><br /> Which One Is More Effective?
  </h2>
  <p className="fark-p">
    When comparing email and WhatsApp in marketing, <b>WhatsApp stands out in terms of open and response rates</b>.
  </p>
  <div className="table-test">
    <table className="comparison-table">
      <thead>
        <tr>
          <th>Criteria</th>
          <th>Email</th>
          <th>WhatsApp</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Open Rate</td>
          <td>15–20%</td>
          <td>90%+</td>
        </tr>
        <tr>
          <td>Instant Response</td>
          <td>Low</td>
          <td>High</td>
        </tr>
        <tr>
          <td>Content Richness</td>
          <td>Moderate</td>
          <td>High</td>
        </tr>
        <tr>
          <td>User Satisfaction</td>
          <td>Increased spam risk</td>
          <td>Direct Communication</td>
        </tr>
      </tbody>
    </table>
  </div>
  <p className="fark-p">
    WhatsApp accelerates the path to purchase by being a more direct and personal channel.
  </p>
</div>



                    <div className="container py40">
  <div className="row thre">
    <div className="col-md-5">
      <h2 className="wp-marketing-twos alt">Make Your Marketing Processes Smarter with Livachat AI</h2>
      <p className="p-wp-marketings alt">
        Bulk messaging is just the first step in digital marketing. But the process doesn’t end there. For brands seeking more advanced, personalized, and AI-powered communication flows, Flatart’s advanced product Livachat AI steps in.
      </p>
      <ul className="ul-wp alt">With Livachat AI:
        <li className="li-wp alt"><span className="bosluk"></span>• You can set up a WhatsApp chatbot</li>
        <li className="li-wp alt"><span className="bosluk"></span>• Create automated sales support systems</li>
        <li className="li-wp alt"><span className="bosluk"></span>• Design dynamic message flows based on user behavior</li>
      </ul>
      <p className="p-wp-marketings alt">
        👉 To discover more, <a href="https://livechatai.com/whatsapp-ai-chatbot" target="blank">visit the Livachat AI page</a>
      </p>
    </div>
    <div className="col-md-7 right">
      <img className="kitles" alt="alt text" src={livachat} loading="lazy" />
    </div>
  </div>
</div>

                    
                   
                 
                </div>
              
            </Layout >
            
        )
    }
}

export default Gads
